import { registerLoaders } from '@loaders.gl/core';
import { ImageLoader } from '@loaders.gl/images';
import { global } from 'probe.gl/env';
import log from '../utils/log';
import { register } from '../debug';
import jsonLoader from '../utils/json-loader';
const version = typeof "8.5.2" !== 'undefined' ? "8.5.2" : global.DECK_VERSION || 'untranspiled source';
const existingVersion = global.deck && global.deck.VERSION;

if (existingVersion && existingVersion !== version) {
  throw new Error("deck.gl - multiple versions detected: ".concat(existingVersion, " vs ").concat(version));
}

if (!existingVersion) {
  log.log(1, "deck.gl ".concat(version))();
  global.deck = Object.assign(global.deck || {}, {
    VERSION: version,
    version,
    log,
    _registerLoggers: register
  });
  registerLoaders([jsonLoader, [ImageLoader, {
    imagebitmap: {
      premultiplyAlpha: 'none'
    }
  }]]);
}

export default global.deck;
//# sourceMappingURL=init.js.map